import React from 'react';
import { motion } from 'framer-motion';
interface StepSectionProps {
  stepNumber: string;
  title: string;
  children: React.ReactNode;
  bgColor?: 'white' | 'gray';
}
export function StepSection({
  stepNumber,
  title,
  children,
  bgColor = 'white'
}: StepSectionProps) {
  return <section className={`py-10 md:py-14 lg:py-20 ${bgColor === 'gray' ? 'bg-slate-50' : 'bg-white'}`} data-id="element-333">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-334">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.5
      }} className="flex flex-col md:flex-row gap-5 md:gap-8 lg:gap-12" data-id="element-335">
          {/* Step Indicator */}
          <div className="flex-shrink-0" data-id="element-336">
            <div className="md:sticky md:top-24" data-id="element-337">
              <span className="text-xs md:text-sm font-bold tracking-wider text-cyan-600 uppercase mb-1 block" data-id="element-338">
                Paso {stepNumber}
              </span>
              <h2 className="text-xl md:text-2xl lg:text-3xl font-bold text-slate-900 max-w-xs leading-tight tracking-tight" data-id="element-339">
                {title}
              </h2>
              <div className="h-1 w-14 md:w-16 bg-cyan-200 mt-3 md:mt-5 rounded-full" data-id="element-340" />
            </div>
          </div>

          {/* Content */}
          <div className="flex-grow pt-0 md:pt-2" data-id="element-341">
            <div className="prose prose-sm md:prose-base prose-slate max-w-none prose-p:text-slate-800 prose-li:text-slate-800" data-id="element-342">
              {children}
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}